import Loadable from "react-loadable";

const LazyRepositories = Loadable({
  loader: () => import(/* webpackChunkName: 'admin-repositories' */ "./repositories"),
  loading: () => 'loading...'
});

export default LazyRepositories;
